import { render, staticRenderFns } from "./SelectableBgColor.vue?vue&type=template&id=ccf17eb0&"
import script from "./SelectableBgColor.vue?vue&type=script&lang=js&"
export * from "./SelectableBgColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports